import React from "react";

const Home = ({ classicHeader, darkTheme, handleNavClick }) => {
  return (
    <section id="home">
      <div className="hero-wrap">
        <div className="hero-mask opacity-8 bg-dark" />

        {/* ---------------image background------------------ */}
        <div
          className="hero-bg parallax"
          style={{ backgroundImage: 'url("images/intro-bg.jpg")' }}
        ></div>

        {/* -------------------video background---------------------- */}

        {/* <div className="player hero-bg parallax">
          <video
            src={videobg}
            autoPlay
            muted
            loop
            style={{ width: "100%", height: "100vh", objectFit: "cover" }}
          ></video>
        </div> */}

        <div className="hero-content section d-flex min-vh-100">
          <div className="container my-auto">
            <div className="row">
              <div className="col-10 mx-auto text-center">
                {/* <p className="text-7 fw-500 text-white mb-2 mb-md-3">My Name is Nic 👋</p> */}
                <h2 className="hero-intro fw-600 text-white mb-3 mb-md-4">
                  I help early-stage startup founders ship.
                </h2>
                <p className="hero-copy text-white mb-3 mb-md-4">
                  Launching a production-ready MVP, or turning a stalled team into one that delivers consistently.
                </p>
                <p className="hero-copy text-white mb-0">
                  Architecture, codebase, infrastructure, and the right engineers hired and led by me, so you're in front of customers and shipping reliably within 30–60 days.
                </p>
                {/* <Typewriter
                    options={{
                      strings: [
                        "I'm a Fractional CTO",
                        "I'm a Problem Solver",
                        "I'm a Strategist",
                        "I'm a Mentor.",
                      ],
                      autoStart: true,
                      loop: true,
                      cursor: "_",
                    }}
                  /> */}
                {/* </h2> */}
                {/* <p className="text-5 text-light mb-4">
                  based in Atlanta
                </p> */}
                <a
                  href="#contact"
                  className="btn btn-outline-primary rounded-pill shadow-none smooth-scroll mt-4"
                  onClick={(e) => {
                    e.preventDefault();
                    handleNavClick("contact");
                  }}
                >
                  Let's Work Together
                </a>
              </div>
            </div>
          </div>
          <a
            href="#about"
            className="scroll-down-arrow text-white smooth-scroll"
            onClick={(e) => {
              e.preventDefault();
              handleNavClick("about");
            }}
          >
            <span className="animated">
              <i className="fa fa-chevron-down" />
            </span>
          </a>
        </div>
      </div>
    </section>
  );
};

export default Home;
